import { emptySplitApi as api } from "../../../emptyApi";
const injectedRtkApi = api.injectEndpoints({
  endpoints: (build) => ({
    apiPortalV1AssessmentsTemplatesList: build.query<
      ApiPortalV1AssessmentsTemplatesListApiResponse,
      ApiPortalV1AssessmentsTemplatesListApiArg
    >({
      query: (queryArg) => ({
        url: `/api/portal/v1/assessments/templates/`,
        params: {
          id: queryArg.id,
          name: queryArg.name,
          sort_order: queryArg.sortOrder,
          target: queryArg.target,
          type_of: queryArg.typeOf,
        },
      }),
    }),
    apiPortalV1AssessmentsTemplatesCreate: build.mutation<
      ApiPortalV1AssessmentsTemplatesCreateApiResponse,
      ApiPortalV1AssessmentsTemplatesCreateApiArg
    >({
      query: (queryArg) => ({
        url: `/api/portal/v1/assessments/templates/`,
        method: "POST",
        body: queryArg.recommendationTemplate,
      }),
    }),
    apiPortalV1AssessmentsTemplatesRetrieve: build.query<
      ApiPortalV1AssessmentsTemplatesRetrieveApiResponse,
      ApiPortalV1AssessmentsTemplatesRetrieveApiArg
    >({
      query: (queryArg) => ({
        url: `/api/portal/v1/assessments/templates/${queryArg.id}/`,
      }),
    }),
    apiPortalV1AssessmentsTemplatesUpdate: build.mutation<
      ApiPortalV1AssessmentsTemplatesUpdateApiResponse,
      ApiPortalV1AssessmentsTemplatesUpdateApiArg
    >({
      query: (queryArg) => ({
        url: `/api/portal/v1/assessments/templates/${queryArg.id}/`,
        method: "PUT",
        body: queryArg.recommendationTemplate,
      }),
    }),
    apiPortalV1AssessmentsTemplatesPartialUpdate: build.mutation<
      ApiPortalV1AssessmentsTemplatesPartialUpdateApiResponse,
      ApiPortalV1AssessmentsTemplatesPartialUpdateApiArg
    >({
      query: (queryArg) => ({
        url: `/api/portal/v1/assessments/templates/${queryArg.id}/`,
        method: "PATCH",
        body: queryArg.patchedRecommendationTemplate,
      }),
    }),
    apiPortalV1AssessmentsTemplatesDestroy: build.mutation<
      ApiPortalV1AssessmentsTemplatesDestroyApiResponse,
      ApiPortalV1AssessmentsTemplatesDestroyApiArg
    >({
      query: (queryArg) => ({
        url: `/api/portal/v1/assessments/templates/${queryArg.id}/`,
        method: "DELETE",
      }),
    }),
  }),
  overrideExisting: false,
});
export { injectedRtkApi as portalApi };
export type ApiPortalV1AssessmentsTemplatesListApiResponse =
  /** status 200  */ RecommendationTemplateRead[];
export type ApiPortalV1AssessmentsTemplatesListApiArg = {
  id?: number;
  name?: string;
  sortOrder?: number;
  target?: number;
  typeOf?: number;
};
export type ApiPortalV1AssessmentsTemplatesCreateApiResponse =
  /** status 201  */ RecommendationTemplateRead;
export type ApiPortalV1AssessmentsTemplatesCreateApiArg = {
  recommendationTemplate: RecommendationTemplate;
};
export type ApiPortalV1AssessmentsTemplatesRetrieveApiResponse =
  /** status 200  */ RecommendationTemplateRead;
export type ApiPortalV1AssessmentsTemplatesRetrieveApiArg = {
  /** A unique integer value identifying this recommendation template. */
  id: number;
};
export type ApiPortalV1AssessmentsTemplatesUpdateApiResponse =
  /** status 200  */ RecommendationTemplateRead;
export type ApiPortalV1AssessmentsTemplatesUpdateApiArg = {
  /** A unique integer value identifying this recommendation template. */
  id: number;
  recommendationTemplate: RecommendationTemplate;
};
export type ApiPortalV1AssessmentsTemplatesPartialUpdateApiResponse =
  /** status 200  */ RecommendationTemplateRead;
export type ApiPortalV1AssessmentsTemplatesPartialUpdateApiArg = {
  /** A unique integer value identifying this recommendation template. */
  id: number;
  patchedRecommendationTemplate: PatchedRecommendationTemplate;
};
export type ApiPortalV1AssessmentsTemplatesDestroyApiResponse = unknown;
export type ApiPortalV1AssessmentsTemplatesDestroyApiArg = {
  /** A unique integer value identifying this recommendation template. */
  id: number;
};
export type RecommendationTemplateStatusEnum =
  | 1
  | 2
  | 3
  | 4
  | 5
  | 9
  | 11
  | 12
  | 99;
export type TypeOf3B0Enum = 1 | 2 | 3 | 4;
export type TargetEnum = 1 | 2;
export type RecommendationTemplate = {
  name: string;
  status?: RecommendationTemplateStatusEnum;
  sort_order?: number | null;
  type_of?: TypeOf3B0Enum;
  target?: TargetEnum;
  template?: any | null;
  /** How long the intervention takes (e.g., '3-6 months', 'Ongoing') */
  time_estimate?: string | null;
  /** What metric/outcome it targets */
  measure?: string | null;
  /** Category of intervention */
  intervention_type?: string | null;
};
export type RecommendationTemplateRead = {
  id: number;
  name: string;
  status?: RecommendationTemplateStatusEnum;
  status_text: string;
  sort_order?: number | null;
  type_of?: TypeOf3B0Enum;
  target?: TargetEnum;
  template?: any | null;
  /** How long the intervention takes (e.g., '3-6 months', 'Ongoing') */
  time_estimate?: string | null;
  /** What metric/outcome it targets */
  measure?: string | null;
  /** Category of intervention */
  intervention_type?: string | null;
  created_at: string;
  updated_at: string;
  in_use: boolean;
};
export type PatchedRecommendationTemplate = {
  name?: string;
  status?: RecommendationTemplateStatusEnum;
  sort_order?: number | null;
  type_of?: TypeOf3B0Enum;
  target?: TargetEnum;
  template?: any | null;
  /** How long the intervention takes (e.g., '3-6 months', 'Ongoing') */
  time_estimate?: string | null;
  /** What metric/outcome it targets */
  measure?: string | null;
  /** Category of intervention */
  intervention_type?: string | null;
};
export type PatchedRecommendationTemplateRead = {
  id?: number;
  name?: string;
  status?: RecommendationTemplateStatusEnum;
  status_text?: string;
  sort_order?: number | null;
  type_of?: TypeOf3B0Enum;
  target?: TargetEnum;
  template?: any | null;
  /** How long the intervention takes (e.g., '3-6 months', 'Ongoing') */
  time_estimate?: string | null;
  /** What metric/outcome it targets */
  measure?: string | null;
  /** Category of intervention */
  intervention_type?: string | null;
  created_at?: string;
  updated_at?: string;
  in_use?: boolean;
};
export const {
  useApiPortalV1AssessmentsTemplatesListQuery,
  useApiPortalV1AssessmentsTemplatesCreateMutation,
  useApiPortalV1AssessmentsTemplatesRetrieveQuery,
  useApiPortalV1AssessmentsTemplatesUpdateMutation,
  useApiPortalV1AssessmentsTemplatesPartialUpdateMutation,
  useApiPortalV1AssessmentsTemplatesDestroyMutation,
} = injectedRtkApi;
